import * as React from 'react';
import { Mutation, MutationFn } from 'react-apollo';

import GET_COACH_AVAILABILITIES_QUERY from 'coaching/queries/GetCoachAvailabilities.gql';
import SET_COACHING_AVAILABILITY_EXCEPTION_MUTATION from 'coaching/mutations/SetCoachingAvailabilityException.gql';
import {
  SetCoachingAvailabilityException,
  SetCoachingAvailabilityExceptionVariables,
} from 'coaching/mutations/__generated__/SetCoachingAvailabilityException';
import ToastActions from 'actions/ToastActions';

export type Props = {
  coachUuid: string;
  startDateTime: string;
  endDateTime: string;
  children: (props: {
    setCoachingAvailabilityException: MutationFn<
      SetCoachingAvailabilityException,
      SetCoachingAvailabilityExceptionVariables
    >;
  }) => React.ReactNode;
};

export default function SetCoachAvailabilityExceptionsContainer(props: Props) {
  return (
    <Mutation<SetCoachingAvailabilityException, SetCoachingAvailabilityExceptionVariables>
      mutation={SET_COACHING_AVAILABILITY_EXCEPTION_MUTATION}
      onCompleted={() => ToastActions.showSuccessToast('Saved your time off')}
      onError={error =>
        ToastActions.showErrorToast(
          'Oops - we weren’t able to save your time off. You may already have a coaching session booked at this time - please contact us to resolve the conflict.'
        )
      }
      refetchQueries={[
        {
          query: GET_COACH_AVAILABILITIES_QUERY,
          variables: {
            coachUuid: props.coachUuid,
            startDateTime: props.startDateTime,
            endDateTime: props.endDateTime,
          },
        },
      ]}>
      {setCoachingAvailabilityException => {
        return props.children({ setCoachingAvailabilityException });
      }}
    </Mutation>
  );
}
